import { TicketWithDependencies } from './ticket-dependency-builder';

export class TicketDependencyAnalyzer {
  // Map of ticket config id => its dependencies
  private dependencyMap: Map<number, TicketWithDependencies>;
  // Which ticket config ids were checked
  private checked = new Set<number>();
  // Which ticket config ids are required for calculating if the checkedTickets can be bought
  private toKeep = new Set<number>();

  constructor(
    private checkedTickets: TicketWithDependencies[],
    private allTickets: TicketWithDependencies[]
  ) {
    this.dependencyMap = this.arrayToMap(allTickets);
  }

  private arrayToMap(allTickets: TicketWithDependencies[]) {
    const result = new Map<number, TicketWithDependencies>();
    for (const ticket of allTickets) {
      result.set(ticket.ticketConfigId, ticket);
    }
    return result;
  }

  public getRelevantTickets(): TicketWithDependencies[] {
    if (this.checked.size === 0) {
      this.calculateAntecedents();
    }
    return this.allTickets.filter((ticket) =>
      this.toKeep.has(ticket.ticketConfigId)
    );
  }

  /**
   * Runs the calculation which results in the the toKeep set being populated
   * with the ticket config IDs which are needed for the checkedTickets
   * conditional checks.
   */
  private calculateAntecedents() {
    for (const ticket of this.checkedTickets) {
      this.populateAntecedents(ticket.ticketConfigId);
    }
  }

  /**
   *
   */
  private populateAntecedents(ticketConfigId: number) {
    // We add it to the checked set so we don't check it multiple times
    this.checked.add(ticketConfigId);
    // Gets the ticket with its dependencies
    if (!this.dependencyMap.has(ticketConfigId)) {
      // If there are no tickets for this ticket config, it is not relevant
      return;
    }
    const ticket = this.dependencyMap.get(ticketConfigId);

    // We have to keep this ticket config since it is relevant
    this.toKeep.add(ticketConfigId);

    // Check antecedents for each ticket config this one depends on
    for (const tcId of ticket.dependsOn) {
      // Maybe the following line is not needed
      this.toKeep.add(tcId);
      if (!this.checked.has(tcId)) {
        this.populateAntecedents(tcId);
      }
    }
  }
}
